<template>
    <div class="notification">
        <h2>{{ message }}</h2>
    </div>
</template>

<script>
const Notification = {
    props: {
        message: {
            type: String,
            require: true
        },
    },
}

export default Notification;
</script>

<style scoped>
.notification {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>